/** Нормализация lat/lng из ответа API (camelCase / PascalCase, number | string). */
export function pickSchoolLat(s) {
    if (!s) return null;
    const v = s.lat ?? s.Lat;
    if (v == null || v === '') return null;
    const n = Number(v);
    return Number.isFinite(n) ? n : null;
}

export function pickSchoolLng(s) {
    if (!s) return null;
    const v = s.lng ?? s.Lng;
    if (v == null || v === '') return null;
    const n = Number(v);
    return Number.isFinite(n) ? n : null;
}

export function hasSchoolCoordinates(s) {
    return pickSchoolLat(s) != null && pickSchoolLng(s) != null;
}
